import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { BackButton, Hamburger, Navigation } from './';
import * as NavigationActions from '../navigation.actions';

class Menu extends Component {
  componentWillUpdate(nextProps) {
    const { location } = this.props;
    if (nextProps.location.pathname !== location.pathname) {
      this.toggle(false);
    }
  }

  onNavigate = () => {
    const { open } = this.props;
    if (open) {
      this.toggle(false);
    }
  };

  onHamburgerClick = () => {
    const { open } = this.props;
    this.toggle(!open);
  };

  toggle = open => {
    const { closeMenu, openMenu } = this.props;

    open ? openMenu() : closeMenu();

    document.body.classList.toggle('no-overflow', open);
  };

  render() {
    const { open } = this.props;
    return (
      <Fragment>
        <Navigation isOpen={open} onNavigate={this.onNavigate} />
        <BackButton isOpen={open} />
        <Hamburger isOpen={open} onClick={this.onHamburgerClick} />
      </Fragment>
    );
  }
}

Menu.propTypes = {
  open: PropTypes.bool.isRequired,
  openMenu: PropTypes.func.isRequired,
  closeMenu: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  const { navigation: { open } } = state;
  return {
    open,
  };
};

export default withRouter(connect(mapStateToProps, NavigationActions)(Menu));



// WEBPACK FOOTER //
// ./src/modules/navigation/components/Menu.js